import { PublicRoutes } from "@/constants/routes";
import { Text } from "@/design-system";
import { Link } from "react-router";
import {
  ALPHA7_LEGAL_NAME,
  ALPHA7_SITE_URL,
  FIDEXA_CNPJ,
  FIDEXA_LEGAL_NAME,
} from "../constants";

const linkClass =
  "text-ds-brand-700 hover:text-ds-brand-800 focus-visible:outline-ds-focus inline-flex min-h-11 cursor-pointer items-center underline underline-offset-4 focus-visible:outline-2";

/**
 * Rodapé mínimo: razão social das duas empresas e o link da política de
 * privacidade, que a LGPD exige onde há coleta de dados. Nada de navegação
 * para o restante do site.
 */
export const PartnerFooter = () => (
  <footer className="border-ds-border mt-auto border-t">
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-3 px-4 py-8 sm:px-6 lg:px-8">
      <Text size="small" tone="subtle">
        {FIDEXA_LEGAL_NAME} · CNPJ {FIDEXA_CNPJ}. Parceria com{" "}
        <a
          href={ALPHA7_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          {ALPHA7_LEGAL_NAME}
        </a>
        .
      </Text>
      <Text size="small" tone="subtle">
        Os dados enviados por este formulário são usados só para o contato
        comercial descrito na página.{" "}
        <Link to={PublicRoutes.POLITICA_PRIVACIDADE} className={linkClass}>
          Política de privacidade
        </Link>
      </Text>
    </div>
  </footer>
);
